exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "tr.title-bar{background-color:#2c2c2c;color:#e9e9e9;font-weight:bold;font-size:13pt}tr.title-bar td{padding:3px;color:#e9e9e9}", ""]);

